import { get, post } from '@/utils/apiBaseAcp.js'
// 设置项目为待修改状态
export const acpProductModified = (option) => {
    return post('/zc_class/ajax/product_modified', option)
}
// 拒绝项目上线申请
export const acpAuditReject = (option) => {
    return post('/zc_class/ajax/audit_reject', option)
}
// 个人愿望拒绝项目上线申请
export const acpWdsAuditReject = (option) => {
    return post('/wds_class/ajax/audit_reject', option)
}

// 获取项目详情富文本
export const getProjectDetailByVersion = (option) => {
    return get('/acp_api/project_statistics/get_project_detail_by_version', option)
}
// 众筹保存草稿
export const edit_draft = (option) => {
    return post('/project_manager/edit_draft', option)
}
// 众筹提交审核
export const submit_version = (option) => {
    return post('/acp_api/project_statistics/submit_version', option)
}
// 视频相关
export const showVideoListAcp = option => {
    return post('/apis/upload/mdmedia/show_video_list', option)
}
// 创意审核
export const ideaAuditAcp = option => {
    return post('/acp_api/md_idea/idea_audit_no_pass', option)
}